export default function SectionDivider({ tone = "light", className = "" }) {
  // A very subtle hairline with a soft blue accent dot in the middle.
  const line =
    tone === "dark"
      ? "from-transparent via-slate-700 to-transparent"
      : "from-transparent via-slate-200 to-transparent";
  return (
    <div
      aria-hidden="true"
      className={`relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${className}`}
    >
      <div className={`h-px w-full bg-gradient-to-r ${line}`} />
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full bg-sky-500 shadow-[0_0_18px_rgba(14,165,233,0.55)]" />
    </div>
  );
}
